/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DrmOperationInterval } from './DrmOperationInterval';
import {
    DrmOperationIntervalFromJSON,
    DrmOperationIntervalFromJSONTyped,
    DrmOperationIntervalToJSON,
} from './DrmOperationInterval';

/**
 * 
 * @export
 * @interface RotorDrillingDrmOperationInterval
 */
export interface RotorDrillingDrmOperationInterval extends DrmOperationInterval {
    /**
     * 
     * @type {number}
     * @memberof RotorDrillingDrmOperationInterval
     */
    ropMax: number;
    /**
     * 
     * @type {number}
     * @memberof RotorDrillingDrmOperationInterval
     */
    pressureMax: number;
    /**
     * 
     * @type {number}
     * @memberof RotorDrillingDrmOperationInterval
     */
    differentialPressure: number;
    /**
     * 
     * @type {number}
     * @memberof RotorDrillingDrmOperationInterval
     */
    weightOnBit: number;
    /**
     * 
     * @type {number}
     * @memberof RotorDrillingDrmOperationInterval
     */
    topDriveTorque: number;
    /**
     * 
     * @type {number}
     * @memberof RotorDrillingDrmOperationInterval
     */
    rpm: number;
    /**
     * 
     * @type {number}
     * @memberof RotorDrillingDrmOperationInterval
     */
    flowRate: number;
}

/**
 * Check if a given object implements the RotorDrillingDrmOperationInterval interface.
 */
export function instanceOfRotorDrillingDrmOperationInterval(value: object): value is RotorDrillingDrmOperationInterval {
    if (!('ropMax' in value) || value['ropMax'] === undefined) return false;
    if (!('pressureMax' in value) || value['pressureMax'] === undefined) return false;
    if (!('differentialPressure' in value) || value['differentialPressure'] === undefined) return false;
    if (!('weightOnBit' in value) || value['weightOnBit'] === undefined) return false;
    if (!('topDriveTorque' in value) || value['topDriveTorque'] === undefined) return false;
    if (!('rpm' in value) || value['rpm'] === undefined) return false;
    if (!('flowRate' in value) || value['flowRate'] === undefined) return false;
    return true;
}

export function RotorDrillingDrmOperationIntervalFromJSON(json: any): RotorDrillingDrmOperationInterval {
    return RotorDrillingDrmOperationIntervalFromJSONTyped(json, false);
}

export function RotorDrillingDrmOperationIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): RotorDrillingDrmOperationInterval {
    if (json == null) {
        return json;
    }
    return {
        ...DrmOperationIntervalFromJSONTyped(json, ignoreDiscriminator),
        'ropMax': json['ropMax'],
        'pressureMax': json['pressureMax'],
        'differentialPressure': json['differentialPressure'],
        'weightOnBit': json['weightOnBit'],
        'topDriveTorque': json['topDriveTorque'],
        'rpm': json['rpm'],
        'flowRate': json['flowRate'],
    };
}

export function RotorDrillingDrmOperationIntervalToJSON(value?: RotorDrillingDrmOperationInterval | null): any {
    if (value == null) {
        return value;
    }
    return {
        ...DrmOperationIntervalToJSON(value),
        'ropMax': value['ropMax'],
        'pressureMax': value['pressureMax'],
        'differentialPressure': value['differentialPressure'],
        'weightOnBit': value['weightOnBit'],
        'topDriveTorque': value['topDriveTorque'],
        'rpm': value['rpm'],
        'flowRate': value['flowRate'],
    };
}

